import { type ReactNode } from "react";

import { cn } from "@/src/lib/utils";

export interface FormSuccessProps {
  children: ReactNode;
  className?: string;
}

export function FormSuccess({ children, className }: FormSuccessProps) {
  return (
    <div
      className={cn(
        "rounded-sm border border-success/20 bg-success/10 px-3.5 py-2.5 text-sm font-medium text-success",
        className,
      )}
    >
      ✓ {children}
    </div>
  );
}
